// Vendors
import { COBRANDED_LIGHT_REGULAR_STYLES } from '@openbank/ziniaweb-ui-components';
import styled from 'styled-components';

const BackgroundFooterComponentStyled = styled.div`
  ${COBRANDED_LIGHT_REGULAR_STYLES.MEDIA_QUERIES.mobileAndTablet} {
    padding-bottom: ${({ theme }) => theme.spacing_250};
    width: 100%;
  }
`;
BackgroundFooterComponentStyled.displayName = 'BackgroundFooterComponentStyled';

export { BackgroundFooterComponentStyled };
